import { AcceptanceStateEnum, EmailStateAcquirerEnum, TypeDocumentEnum, ProcessResultCode, PayrollDocumentType, EmailSendType } from "./GeneralEnums";

export const documentTypesOptions = [
  { key: 0, text: "Sin filtro",value: -1 },
  { key: TypeDocumentEnum.InvoiceSale, text: "Factura electrónica de venta",value: TypeDocumentEnum.InvoiceSale},
  { key: TypeDocumentEnum.InvoiceExport, text: "Factura electrónica de venta - exportación",value: TypeDocumentEnum.InvoiceExport},
  { key: TypeDocumentEnum.InvoiceContingency, text: "Documento electrónico de transmisión - tipo 3",value: TypeDocumentEnum.InvoiceContingency},
  { key: TypeDocumentEnum.InvoiceSaleFourType, text: "Factura electrónica de venta - tipo 4",value: TypeDocumentEnum.InvoiceSaleFourType},
  { key: TypeDocumentEnum.DocumentSupport, text: "Documento soporte",value: TypeDocumentEnum.DocumentSupport},
  { key: TypeDocumentEnum.EquivalentDocumentSPD, text: "Documento equivalente",value: TypeDocumentEnum.EquivalentDocumentSPD},
  { key: TypeDocumentEnum.CreditNote, text: "Nota crédito",value:TypeDocumentEnum.CreditNote },
  { key: TypeDocumentEnum.DebitNote, text: "Nota débito",value:TypeDocumentEnum.DebitNote },
  { key: TypeDocumentEnum.EquivalentDocumentCreditNote, text: "Nota crédito ajuste documento equivalente",value:TypeDocumentEnum.EquivalentDocumentCreditNote },
  { key: TypeDocumentEnum.EquivalentDocumentDebitNote, text: "Nota débito ajuste documento equivalente",value:TypeDocumentEnum.EquivalentDocumentDebitNote },
  { key: TypeDocumentEnum.AdjustmentNote, text: "Nota de ajuste documento soporte",value:TypeDocumentEnum.AdjustmentNote },
];

export const acceptanceState = [
  { key: -1, text: "Sin filtro",value: -1},
  { key: AcceptanceStateEnum.Undefined, text: "Pendiente por aceptación",value:AcceptanceStateEnum.Undefined },
  { key: AcceptanceStateEnum.TacitlyAccepted, text: "Aceptada Tacitamente",value:AcceptanceStateEnum.TacitlyAccepted },
  { key: AcceptanceStateEnum.AcceptedByCustomer, text: "Aceptada por cliente",value:AcceptanceStateEnum.AcceptedByCustomer},
  { key: AcceptanceStateEnum.AcceptedByUser, text: "Aceptado por usuario",value:AcceptanceStateEnum.AcceptedByUser},
  { key: AcceptanceStateEnum.RejectedByCustomer, text: "Rechazada por cliente",value:AcceptanceStateEnum.RejectedByCustomer},
  { key: AcceptanceStateEnum.RejectedByUser, text: "Rechazada por usuario ",value:AcceptanceStateEnum.RejectedByUser},
];

export const emailStateAcquirer = [
  { key: -1, text: "Sin filtro",value: -1},
  { key: EmailStateAcquirerEnum.Undefined, text: "Pendiente por envío",value:EmailStateAcquirerEnum.Undefined },
  { key: EmailStateAcquirerEnum.BlockedEmail, text: "Email cliente bloqueado",value: EmailStateAcquirerEnum.BlockedEmail},
  { key: EmailStateAcquirerEnum.InvalidEmail, text: "Email cliente inválido",value: EmailStateAcquirerEnum.InvalidEmail},
  { key: EmailStateAcquirerEnum.SendEmail, text: "Email recibido por el cliente",value: EmailStateAcquirerEnum.SendEmail},
  { key: EmailStateAcquirerEnum.FailedShipping, text: "Envío email fallido",value: EmailStateAcquirerEnum.FailedShipping},
];

export const processResultCode = [
  { key: -1, text: "Sin filtro", value: -1 },
  { key: ProcessResultCode.InProcess, text: "En proceso de envío", value: ProcessResultCode.InProcess },
  { key: ProcessResultCode.SendSuccessInValidationProcess, text: "En proceso de validación", value: ProcessResultCode.SendSuccessInValidationProcess },
  { key: ProcessResultCode.SendSuccessApproved, text: "Aprobado por la DIAN", value: ProcessResultCode.SendSuccessApproved },
  { key: ProcessResultCode.SendSuccessApprovedWithWarnings, text: "Aprobado con notificaciones por la DIAN", value: ProcessResultCode.SendSuccessApprovedWithWarnings },
  { key: ProcessResultCode.SendSuccessRejected, text: "Rechazado por la DIAN", value: ProcessResultCode.SendSuccessRejected },
  { key: ProcessResultCode.PTRejected, text: "Rechazado por plataforma", value: ProcessResultCode.PTRejected },
  { key: ProcessResultCode.PendingToSendContingency, text: "Pendiente de envío por contingencia", value: ProcessResultCode.PendingToSendContingency },
  { key: ProcessResultCode.PreviousApproved, text: "Aprobado previamente", value: ProcessResultCode.PreviousApproved },
  { key: ProcessResultCode.PendingDianVerification, text: "Pendiente de verificación DIAN", value: ProcessResultCode.PendingDianVerification },
];

export const pageSizeOptions = [
  { key: 30, text: "30", value: 30 },
  { key: 50, text: "50", value: 50 },
  { key: 100, text: "100", value: 100 },
  { key: 150, text: "150", value: 150 },
];

export const getDocumentType = (key: number) => {
  return documentTypesOptions.find((type) => type.key === key)?.text || "";
};
export const getAcceptanceState = (key: number) => {
  return acceptanceState.find((type) => type.key === key)?.text || "";
};
export const getEmailStateAcquirer = (key: number) => {
  return emailStateAcquirer.find((type) => type.key === key)?.text || "";
};
export const getProcessResultCode = (key: number) => {
  return processResultCode.find((type) => type.key === key)?.text || "";
};

export const payrollDocumentTypesOptions = [
  { key: 0, text: "Sin filtro", value: -1 },
  { key: PayrollDocumentType.Individual, text: "Nómina individual", value: PayrollDocumentType.Individual },
  { key: PayrollDocumentType.Adjustment, text: "Nota de ajuste de nómina individual", value: PayrollDocumentType.Adjustment },
];

export const getPayrollDocumentType = (key: number) => {
  return payrollDocumentTypesOptions.find((type) => type.key === key)?.text || "";
};

export const emailSendTypeOptions = [
  {
    key: EmailSendType.AutomaticAndWithRequest,
    text: "Automático y manual",
    value: EmailSendType.AutomaticAndWithRequest,
    description: "El correo se envía automáticamente al generar la representación gráfica y también se puede reenviar manualmente.",
  },
  {
    key: EmailSendType.Automatic,
    text: "Solo automático",
    value: EmailSendType.Automatic,
    description: "El correo se envía automáticamente al generar la representación gráfica. No se permiten reenvíos manuales.",
  },
  {
    key: EmailSendType.WithRequest,
    text: "Solo manual",
    value: EmailSendType.WithRequest,
    description: "El correo solo se envía cuando el usuario o el ERP lo solicitan.",
  },
  {
    key: EmailSendType.None,
    text: "No enviar correo",
    value: EmailSendType.None,
    description: "No se envía correo a los adquirientes.",
  },
];

export const getEmailSendTypeDescription = (key: number) => {
  return emailSendTypeOptions.find((type) => type.key === key)?.description || "";
};
